<template>
  <div>
    <v-btn class="d-none d-lg-flex" text @click.stop="dialog = true" v-if="!$store.state.inAk">Войти</v-btn>
    <v-btn
      class="d-xs-flex d-lg-none mr-4"
      text
      @click.stop="dialog = true"
      x-small
      v-if="!$store.state.inAk"
    >Войти</v-btn>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title class="headline">Вход</v-card-title>
        <v-col>
          <v-row class="px-4">
            <v-text-field
              @keypress.enter="di()"
              ref="in1"
              outlined
              v-model.trim="email"
              :label="textEm"
              :color="colorEm"
              class="rounded-xl"
              background-color="grey lighten-2"
            ></v-text-field>
          </v-row>
          <v-row class="px-4">
            <v-text-field
              @keypress.enter="di()"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show1 ? 'text' : 'password'"
              @click:append="show1 = !show1"
              ref="in2"
              outlined
              :label="textEm2"
              :color="colorEm2"
              v-model.trim="password"
              class="rounded-xl"
              background-color="grey lighten-2"
            ></v-text-field>
          </v-row>
          <v-row class="px-4 mt-n5">
            <v-btn text small class="text-capitalize">Забыли пароль?</v-btn>
          </v-row>
        </v-col>
        <v-card-actions>
          <v-col cols="12" class="px-6">
            <v-row>
              <v-btn color="yellow darken-1" rounded depressed block @click="di()">Войти</v-btn>
              <v-snackbar v-model="snackbar" color="cyan darken-2" :timeout="3000" top>
                {{label}}
                <template v-slot:action="{ attrs }">
                  <v-btn text v-bind="attrs" @click="snackbar = false">Закрыть</v-btn>
                </template>
              </v-snackbar>
            </v-row>
            <v-row justify="center">
              <v-card-subtitle class="mt-1 pa-0">Ещё нет аккаунта?</v-card-subtitle>
              <v-btn
                :ripple="false"
                small
                class="pa-0 text-capitalize"
                text
                @click="jump('/Reg')"
              >Зарегистрируйтесь</v-btn>
            </v-row>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Exemplemix } from "../../mixinEx";
import { email, required, minLength } from "vuelidate/lib/validators";
export default {
  mixins: [Exemplemix],
  validations: {
    email: { email, required },
    password: { required, minLength: minLength(6) },
  },
  data: () => ({
    show1: false,
    dialog: false,
    snackbar: false,
    label: "Пользователь не найден",
    textEm: "Ваш E-mail",
    colorEm: "blue",
    textEm2: "Ваш пароль",
    colorEm2: "blue",
    email: "",
    password: "",
    f3: [
      {
        email: "Ain@mail.ru",
        password: "qweasd",
        fio: "Фаттахов_Айнур_Джамилевич",
        polz: "1",
        idNam: "Ain",
      },
      {
        email: "Dan@mail.ru",
        password: "qweasd",
        fio: "Горбунов_Даниил_Васильевич",
        polz: "2",
        idNam: "Dan",
        Org: "Татнефть",
      },
      {
        email: "Fil@mail.ru",
        password: "qweasd",
        fio: "Филимонова_Тамара_Константиновна",
        polz: "3",
        idNam: "Fil",
        Org: "КГЭУ",
      },
    ],
  }),
  created() {
    if (this.$ls.get("newpol") != undefined) {
      this.f3.push(this.$ls.get("newpol"));
    }
  },
  watch: {
    email() {
      if (
        (this.$v.email.$dirty && !this.$v.email.required) ||
        (this.$v.email.$dirty && !this.$v.email.email)
      ) {
        this.colorEm = "red";
        if (this.$v.email.$dirty && !this.$v.email.required) {
          this.textEm = "Заполните пустое поле";
        } else if (this.$v.email.$dirty && !this.$v.email.email) {
          this.textEm = "Введите корректный E-mail";
        }
      } else {
        this.textEm = "Ваш E-mail";
        this.colorEm = "blue";
      }
    },
    password() {
      if (
        (this.$v.password.$dirty && !this.$v.password.required) ||
        (this.$v.password.$dirty && !this.$v.password.minLength)
      ) {
        this.colorEm2 = "red";
        if (this.$v.password.$dirty && !this.$v.password.required) {
          this.textEm2 = "Заполните пустое поле";
        } else if (this.$v.password.$dirty && !this.$v.password.minLength) {
          this.textEm2 = "Некорректный пароль";
        }
      } else {
        this.textEm2 = "Ваш пароль";
        this.colorEm2 = "blue";
      }
    },
  },
  methods: {
    di() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        if (
          (this.$v.email.$dirty && !this.$v.email.required) ||
          (this.$v.email.$dirty && !this.$v.email.email)
        ) {
          this.$refs.in1._self.focus();
          this.colorEm = "red";
          if (this.$v.email.$dirty && !this.$v.email.required) {
            this.textEm = "Заполните пустое поле";
          } else if (this.$v.email.$dirty && !this.$v.email.email) {
            this.textEm = "Введите корректный E-mail";
          }
        } else {
          this.textEm = "Ваш E-mail";
          this.colorEm = "blue";
          if (
            (this.$v.password.$dirty && !this.$v.password.required) ||
            (this.$v.password.$dirty && !this.$v.password.minLength)
          ) {
            this.$refs.in2._self.focus();
            this.colorEm2 = "red";
            if (this.$v.password.$dirty && !this.$v.password.required) {
              this.textEm2 = "Заполните пустое поле";
            } else if (this.$v.password.$dirty && !this.$v.password.minLength) {
              this.textEm2 = "Пароль не соответствует требованиям";
            }
          } else {
            this.textEm2 = "Ваш пароль";
            this.colorEm2 = "blue";
          }
        }

        return;
      }
      for (var l = 0; l < this.f3.length; l++) {
        if (
          this.email == this.f3[l].email &&
          this.password == this.f3[l].password
        ) {
          for (var i in this.f3[l]) {
            this.$ls.set(i, this.f3[l][i]);
          }
        } else if (this.email == this.f3[l].email) {
          this.label = "Пароль не подходит";
          this.snackbar = true;
          break;
        } else {
          this.label = "Пользователь не найден";
          this.snackbar = true;
        }
      }
      if (this.$ls.get("fio") != undefined) {
        this.$ls.set("inAk", "true");
        this.$store.state.inAk = true;
        this.email = "";
        this.password = "";
        this.dialog = false;
        location.reload();
      } else {
        this.snackbar = true;
      }
    },
  },
};
</script>

<style >
.invalid {
  color: red;
}
</style>